import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Display buyer identification label based on FA(3) XSD choice: NIP / VAT UE / other tax number / BrakID */
export function formatBuyerIdentification(party: {
  nip?: string; brakID?: number; kodUE?: string; nrVatUE?: string;
  taxId?: { kind: string; country?: string | null; number?: string | null } | null;
}): string {
  // taxId is resolved by the backend with the same rule as the KSeF XML — no rule duplicated here
  switch (party.taxId?.kind) {
    case "NIP": return `NIP: ${party.taxId.number}`;
    case "VATUE": return `VAT UE: ${party.taxId.country}${party.taxId.number}`;
    case "NRID": return `Nr id. podatkowy (${party.taxId.country}): ${party.taxId.number}`;
    case "BRAKID": return "Brak NIP (BrakID)";
  }
  if (party.nip) return `NIP: ${party.nip}`;
  if (party.kodUE && party.nrVatUE) return `VAT UE: ${party.kodUE}${party.nrVatUE}`;
  if (party.brakID === 1) return "Brak NIP (BrakID)";
  return "—";
}
